<template>
    <div class="navigation-bar">
        <nav class="navigation-bar-wrap">
            <ul class="navigation-bar-list">
                <li v-for="item in navigation" :key="item.link" class="navigation-bar-list-item">
                    <v-menu v-if="item.subItems.length">
                        <template #activator="{ props }">
                            <v-btn variant="plain" v-bind="props" :ripple="false">
                                <template v-if="item?.icon" #prepend>
                                    <v-icon :icon="item.icon"></v-icon>
                                </template>
                                {{ t(item.text) }}
                            </v-btn>
                        </template>

                        <v-list>
                            <v-list-item
                                v-for="(subItem, index) in item.subItems"
                                :key="index"
                                :value="index"
                                color="primary"
                                @click="navigateTo(subItem.link)"
                            >
                                <template v-if="subItem?.icon" #prepend>
                                    <v-icon :icon="subItem.icon"></v-icon>
                                </template>
                                <v-list-item-title>
                                    {{ t(subItem.text) }}
                                </v-list-item-title>
                            </v-list-item>
                        </v-list>
                    </v-menu>
                    <v-btn v-if="!item.subItems.length" variant="plain" :ripple="false" @click="navigateTo(item.link)">
                        <template v-if="item?.icon" #prepend>
                            <v-icon :icon="item.icon"></v-icon>
                        </template>
                        {{ t(item.text) }}
                    </v-btn>
                </li>
            </ul>
        </nav>
    </div>
</template>

<script lang="ts" setup>
import { reactive } from 'vue';
import { APP_NAVIGATION } from '../../../config/app.config';
import type { INavigationItem } from '../../../shared/interfaces/navigation-item.interface';
import { useI18n } from 'vue-i18n';
import { useRouter } from 'vue-router';
import { cloneDeep, filter, forEach, set } from 'lodash';
import { AuthService } from '../../auth/services/auth.service';
import { LocalStorageService } from '../../../shared/services/local-storage.service';

const { t } = useI18n();
const router = useRouter();
const authServices = new AuthService();
const localStorage = new LocalStorageService();

const reworkAppNavigation = (): INavigationItem[] => {
    const mappedNavigation: INavigationItem[] = [];
    forEach(APP_NAVIGATION, (navItem) => {
        if (authServices.hasPermissionByRoles(navItem.roles)) {
            const cloneNavItem = cloneDeep(navItem);

            const mappedSubNavItems = filter(navItem.subItems, (x) => !!authServices.hasPermissionByRoles(x.roles));
            set(cloneNavItem, 'subItems', mappedSubNavItems);
            mappedNavigation.push(cloneNavItem);
        }
    });
    return mappedNavigation;
};

const navigateTo = async (name: string): Promise<void> => {
    if (name === 'Manage') {
        // eslint-disable-next-line @typescript-eslint/no-unused-expressions
        localStorage.getItem('searchType') === 'machines'
            ? await router.push({ name: 'MachinesHome' })
            : await router.push({ name: 'ImplementsHome' });
        return;
    }
    await router.push({ name });
};

const navigation: INavigationItem[] = reactive(reworkAppNavigation());
</script>
<style lang="scss">
.navigation-bar {
    .v-btn {
        .v-btn__content {
            font-size: 14px;
            text-transform: none;
        }
    }
    &-wrap {
        width: 100%;
    }
    &-list {
        display: flex;
        flex-direction: row;

        &-item {
            list-style: none;
        }
    }
}
</style>
